import { render, staticRenderFns } from "./successfulCertification.vue?vue&type=template&id=5266ae7b&scoped=true&"
import script from "./successfulCertification.vue?vue&type=script&lang=js&"
export * from "./successfulCertification.vue?vue&type=script&lang=js&"
import style0 from "./successfulCertification.vue?vue&type=style&index=0&id=5266ae7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5266ae7b",
  null
  
)

export default component.exports